import React, { useContext, useState, useEffect, useRef } from 'react';
import ReactApexChart from 'react-apexcharts';
import ApexCharts from 'apexcharts';
import config from '../../envconfig';
import { UserContext } from '../common/UserContext';
import { useNavigate } from 'react-router-dom';


const OrderChart = () => {
  const [selectedOption, setSelectedOption] = useState('1');
  const [selectedDataPoint, setSelectedDataPoint] = useState(null);
  const chartAreaRef = useRef(null);
  const chartId = 'order-status-chart';
  
  const navigate = useNavigate();
  // console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        id: chartId,
        type: 'bar',
        height: '100%',
        width: '100%',
        toolbar: {
          show: false,
        },

        offsetY: -20,
        events: {
          dataPointSelection: function (event, chartContext, config) {
            const { seriesIndex, dataPointIndex, selectedDataPoints } = config;
            const isSelected = Array.isArray(selectedDataPoints?.[seriesIndex]) &&
              selectedDataPoints[seriesIndex].includes(dataPointIndex);

            if (isSelected) {
              setSelectedDataPoint({ seriesIndex, dataPointIndex });
            } else {
              setSelectedDataPoint(null);
            }
          },
          click: function (event, chartContext, { seriesIndex, config }) {
            if (typeof seriesIndex !== 'undefined') {
              const seriesName = config.series[seriesIndex]?.name;
              if (seriesName) {
                console.log(`Legend clicked: ${seriesName}`);
                if (seriesName === "Created") {
                  navigate("/dashboard/orderlist")
                }
                if (seriesName === "Rejected") {
                  navigate("/dashboard/OrderVerification")
                }
              }
            }
          }
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          borderRadius: 4,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      xaxis: {
        categories: [],
        labels: {
          trim: false,
          hideOverlappingLabels: false,
          maxHeight: 60,
        },
      },
      grid: {
        padding: {
          bottom: 16,
        },
      },
      yaxis: {
        title: {
          text: 'Value',
        },
      },
      tooltip: {
  x: {
    formatter: function (val) {
      return `Month : ${val}`;
    }
  },
  y: {
    formatter: function (val, { seriesIndex, w }) {
      const name = w.globals.seriesNames[seriesIndex];
      return `${name} : ${val}`;
    },
    title: {
      formatter: () => ''  // 🛠️ This disables the automatic "Created:"
    }
  }
},
      fill: {
        opacity: 1,
      },
      title: {
        text: 'Order Data',
        align: 'left',
        margin: 10,
        offsetX: 0,
        offsetY: -9,
        floating: false,
        style: {
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#2B2A29',
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'center',
        offsetY: -15,
      },
      colors: ['#00A7E2', '#4AB97D', '#D25141', '#3677a9'],
      // colors: ['#5697c9', '#3677a9', '#275579', '#081118'],
    },
  });

  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId, UM_UserType } = useContext(UserContext);
  

  function formatDate(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
}
  const handleDropdownChange = async (e) => {
  const selectedValue = e.target.value;
  setSelectedOption(selectedValue);

  const now = new Date();
  let startDate, endDate;

  switch (selectedValue) {
    case '1': { // This Month
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      startDate = formatDate(firstDay);
      endDate = formatDate(lastDay);
      break;
    }

    case '2': { // Last Month
      const firstDay = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth(), 0);
      startDate = formatDate(firstDay);
      endDate = formatDate(lastDay);
      break;
    }

    case '3': { // Last 3 Months
      const firstDay = new Date(now.getFullYear(), now.getMonth() - 2, 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      startDate = formatDate(firstDay);
      endDate = formatDate(lastDay);
      break;
    }

    case '6': { // Last 6 Months
      const firstDay = new Date(now.getFullYear(), now.getMonth() - 5, 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      startDate = formatDate(firstDay);
      endDate = formatDate(lastDay);
      break;
    }

    case '12': { // Last 1 Year
      const firstDay = new Date(now.getFullYear(), now.getMonth() - 11, 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      startDate = formatDate(firstDay);
      endDate = formatDate(lastDay);
      break;
    }

    default:
      console.error('Invalid value selected');
      return;
  }

  console.log('Start Date:', startDate);
  console.log('End Date:', endDate);

  let apiUrl = `${config.API_URL}/api/order-status-summary`;

  const requestBody = {
    startDate,
    endDate,
    UM_UserType,
    UM_CompanyID,
    selectedScpId
  };

  console.log("RequestBody:", requestBody);

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    console.log("RESPO-",response)
    const data = await response.json();
    console.log("DATA-",data);
    processChartData(data);
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

  const processChartData = (data) => {
  // Use a Map to group status counts by YearMonth
  const groupedData = {};

  data.forEach(item => {
    const { YearMonth, StatusDescription, StatusCount, status } = item;

    // Only include the relevant statuses
    if (![1, 2, 3, 6].includes(status)) return;

    if (!groupedData[YearMonth]) {
      groupedData[YearMonth] = {
        Created : 0,
        Approved : 0,
        Rejected : 0,
        Completed : 0,
      };
    }

    // Add the status count to the correct field
    if (status === 1) groupedData[YearMonth].Created += StatusCount || 0;
    else if (status === 2) groupedData[YearMonth].Approved += StatusCount || 0;
    else if (status === 3) groupedData[YearMonth].Rejected += StatusCount || 0;
    else if (status === 6) groupedData[YearMonth].Completed += StatusCount || 0;
  });

  // Now prepare the chart series and categories
  const sortedMonths = Object.keys(groupedData).sort(); // Ensure chronological order
  const categories = sortedMonths;
  const createdData = [];
  const approvedData = [];
  const rejectedData = [];
  const completedData = [];

  sortedMonths.forEach(month => {
    const item = groupedData[month];
    createdData.push(item.Created);
    approvedData.push(item.Approved);
    rejectedData.push(item.Rejected);
    completedData.push(item.Completed);
  });

  const series = [
    { name: 'Created', data: createdData },
    { name: 'Approved', data: approvedData },
    { name: 'Rejected', data: rejectedData },
    { name: 'Completed', data: completedData },
  ];

  setChartData(prev => ({
    ...prev,
    series,
    options: {
      ...prev.options,
      xaxis: {
        categories,
      },
    },
  }));
  setSelectedDataPoint(null);
};
  useEffect(() => {
    handleDropdownChange({ target: { value: selectedOption } });
  }, [selectedOption]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!selectedDataPoint) return;
      if (chartAreaRef.current && !chartAreaRef.current.contains(event.target)) {
        ApexCharts.exec(
          chartId,
          'toggleDataPointSelection',
          selectedDataPoint.seriesIndex,
          selectedDataPoint.dataPointIndex
        );
        setSelectedDataPoint(null);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [selectedDataPoint]);

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', zIndex: 2 }}>
        <select
          className="DropdownGraph"
          style={{ zIndex: 2 }}
          value={selectedOption}
          onChange={handleDropdownChange}
        >
          <option value="1">This Month</option>
          <option value="2">Last Month</option>
          <option value="3">Last 3 Months</option>
          <option value="6">Last 6 Months</option>
          <option value="12">Last 1 Year</option>
        </select>
      </div>

      <div ref={chartAreaRef} style={{ flexGrow: 1, zIndex: 1, paddingBottom: '8px' }}>
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height="100%"
          width="100%"
        />
      </div>
    </div>
  );
};

export default OrderChart;
